"use strict";Object.defineProperty(exports, "__esModule", {value: true});



var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/separator/separator.tsx
var TagName = "hr";
var useSeparator = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSeparator2({ orientation = "horizontal", ...props }) {
    props = {
      role: "separator",
      "aria-orientation": orientation,
      ...props
    };
    return props;
  }
);
var Separator = _PTOCUU2Dcjs.forwardRef.call(void 0, function Separator2(props) {
  const htmlProps = useSeparator(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useSeparator = useSeparator; exports.Separator = Separator;
